module.exports = __webpack_public_path__ + "static/media/guadalupe_oro.d45b1b31.png";